<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Setting Layout Lines- Report Balance Sheet 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="saveLayout()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
        </div>
      </div>
      <b-row >
        <b-col cols="5">
                <b-form-group label-cols=3 label="Line Layout Name">
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" ></b-form-select>
                </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label-cols=3 label="New Layout Name">
              <b-form-input v-model="filter.newLayout"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-cols=3 >
                <b-button class="btn btn-danger" @click="delLayout()" > <i class="fa fa-trash"></i> Delete</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-card-group>
          <b-card >
            <b-table
              class="mb-0"
              ref="tabelAktiva"
              bordered
              responsive striped hover small
              style="font-size:smaller;" 
              :items="tblAktiva.items"
              :fields="tblAktiva.fields"
               @row-clicked="aktivaClicked" 
            >
              <template v-slot:cell(uraian)="data">
                <span v-if="(data.item.judul=='Y')" v-html="data.item.uraian" style="font-weight:bold;" :style="`margin-left:${data.item.spasi*5}px`"></span>
                <span v-else v-html="data.item.uraian" :style="`margin-left:${data.item.spasi*5}px`"></span>
              </template>

              <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <a href="javascript:void(0)" @click.stop="insertAktiva($event, data.item, data.index)">
                      insert
                    </a>
                    |
                    <a href="javascript:void(0)" @click.stop="editAktiva(data.item,data.toggleDetails)">
                      edit
                    </a>
                    |
                    <a href="javascript:void(0)" class="text-danger" @click.stop="delAktiva(data.index)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
              </template>
            <template v-slot:row-details="row">
              <b-card no-body class="row-details-form">
                <b-row class="mt-2 mr-2">
                  <b-col class="pr-1" cols="6">
                      <b-form-group label-cols=3 label="GL Account">
                            <b-input-group >
                                <b-form-input readonly v-model="tblAktiva.obj.glAccount" ></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click.stop="showLkuCoa('tblAktiva')">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group >
                      </b-form-group>
                      <b-form-group label-cols=3 label="Item Code">
                        <b-form-row>
                          <b-col md="5">
                          <b-form-input v-model="tblAktiva.obj.kodeacc" placeholder="kode"></b-form-input>
                          </b-col>
                          <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Seq #.</span></b-input-group-prepend>
                                <b-form-input v-model="tblAktiva.obj.nomor" placeholder="Row Number" type="number"></b-form-input>
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                      </b-form-group>

                      <b-form-group  label-cols=3  label="Description (printed)" >
                          <b-form-input v-model="tblAktiva.obj.uraian" ></b-form-input>
                      </b-form-group>
                      <b-form-group label-cols=3  label="Description Space" >
                          <b-row>
                              <b-col  cols="4">
                                  <b-form-input v-model="tblAktiva.obj.spasi" placeholder="Space" type="number"></b-form-input>
                              </b-col>
                              <b-col  cols="8">
                                <b-form-group label-cols=5 label="Font Bold">
                                    <b-form-select v-model="tblAktiva.obj.judul" :plain="true" :options="dataList.FontBold"></b-form-select>                          
                                </b-form-group>
                              </b-col>
                          </b-row>
                      </b-form-group>
                  </b-col>
                  <b-col cols="6">
                      <b-form-group label-cols=3  label="Row Name " >
                          <b-row>
                              <b-col cols="6"><b-form-input v-model="tblAktiva.obj.nm_rumus" placeholder="Name"></b-form-input></b-col>
                          </b-row>
                      </b-form-group>
                      <b-form-group label-cols=3  label="Row Formula " >
                          <b-form-input v-model="tblAktiva.obj.rumus" placeholder="Row Formula"></b-form-input>
                      </b-form-group>
                      <b-form-group label-cols=3  label="Subtotal Flag " >
                          <b-row>
                              <b-col cols="6">
                                <b-form-select v-model="tblAktiva.obj.garis" :plain="true" :options="dataList.FlagTotal"></b-form-select>                          
                              </b-col>
                          </b-row>
                      </b-form-group>
                  <b-row class="justify-content-center mb-2">
                      <b-button class="btn btn-info mr-1" @click.stop="saveAktiva()">Update</b-button>
                      <b-button class="btn btn-warning ml-1" @click.stop="row.toggleDetails">Close</b-button>
                  </b-row>
                      
                  </b-col>
                </b-row>
              </b-card>
            </template>                        
            </b-table>            
          </b-card>
          <b-card>
            <b-table
              class="mb-0"
              ref="tabelPasiva"
              bordered
              responsive striped hover small
              style="font-size:smaller;" 
              :items="tblPasiva.items"
              :fields="tblPasiva.fields"
               @row-clicked="pasivaClicked" 
            >
              <template v-slot:cell(uraian)="data">
                <span v-if="(data.item.judul=='Y')" v-html="data.item.uraian" style="font-weight:bold;" :style="`margin-left:${data.item.spasi*5}px`"></span>
                <span v-else v-html="data.item.uraian" :style="`margin-left:${data.item.spasi*5}px`"></span>
              </template>
              <template v-slot:cell(action)="data">
                  <div class="text-center">
                    <a href="javascript:void(0)" @click.stop="insertPasiva($event, data.item, data.index)">
                      insert
                    </a>
                    |
                    <a href="javascript:void(0)" @click.stop="editPasiva(data.item,data.toggleDetails)">
                      edit
                    </a>
                    |
                    <a href="javascript:void(0)" class="text-danger" @click.stop="delPasiva(data.index)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
              </template>
              <template v-slot:row-details="row">
                <b-card no-body class="row-details-form">
                  <b-row class="mt-2 mr-2">
                    <b-col class="pr-1" cols="6">
                        <b-form-group label-cols=3 label="GL Account">
                              <b-input-group >
                                  <b-form-input readonly v-model="tblPasiva.obj.glAccount" ></b-form-input>
                                  <b-input-group-append>
                                  <b-btn text="Button" @click.stop="showLkuCoa('tblPasiva')">
                                      <i class="fa fa-search"></i>
                                  </b-btn>
                                  </b-input-group-append>
                              </b-input-group>
                        </b-form-group>
                      <b-form-group label-cols=3 label="Item Code">
                        <b-form-row>
                          <b-col md="5">
                          <b-form-input v-model="tblPasiva.obj.kodeacc" placeholder="kode"></b-form-input>
                          </b-col>
                          <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Seq #.</span></b-input-group-prepend>
                                <b-form-input v-model="tblPasiva.obj.nomor" placeholder="Row Number" type="number"></b-form-input>
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                      </b-form-group>

                        <b-form-group  label-cols=3  label="Description(printed)" >
                            <b-form-input v-model="tblPasiva.obj.uraian" ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Description Space" >
                            <b-row>
                                <b-col  cols="4">
                                    <b-form-input v-model="tblPasiva.obj.spasi" placeholder="Space" type="number"></b-form-input>
                                </b-col>
                                <b-col  cols="8">
                                  <b-form-group label-cols=5 label="Font Bold">
                                      <b-form-select v-model="tblPasiva.obj.judul" :plain="true" :options="dataList.FontBold"></b-form-select>                          
                                  </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label-cols=3  label="Row Name " >
                            <b-row>
                                <b-col cols="6"><b-form-input v-model="tblPasiva.obj.nm_rumus" placeholder="Name"></b-form-input></b-col>
                            </b-row>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Row Formula " >
                              <b-form-input v-model="tblPasiva.obj.rumus" placeholder="Row Formula"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Subtotal Flag " >
                            <b-row>
                                <b-col cols="6">
                                  <b-form-select v-model="tblPasiva.obj.garis" :plain="true" :options="dataList.FlagTotal"></b-form-select>                          
                                </b-col>
                            </b-row>
                        </b-form-group>
                      <b-row class="justify-content-center mb-2">
                          <b-button class="btn btn-info mr-1" @click.stop="savePasiva()">Update</b-button>
                          <b-button class="btn btn-warning ml-1" @click.stop="row.toggleDetails">Close</b-button>
                      </b-row>
                        
                    </b-col>
                  </b-row>
                </b-card>
              </template>                        
            </b-table>            
          </b-card>
      </b-card-group>


      <b-row class="justify-content-center mb-2">
          <button class="btn btn-primary mr-1" @click="saveLayout()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Cancel</b-button>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>        
        <vue-simple-context-menu
            :elementId="'myUniqueId'"
            :options="contextMenu"
            :ref="'vueSimpleContextMenu'"
            v-on:clicked="optionClicked">
        </vue-simple-context-menu>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#0000ff" ></loading>       

  </div>
</template>

<style lang="scss">
  .vue-simple-context-menu {
      &--active {
      }
  
      &__item {
          &:hover { }
      }
  }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueSimpleContextMenu from "../../components/vue-simple-context-menu";
import lkuCoa from "../lookup/lkuConsolidaCoa";
import moment from 'moment';
import toastr from "mini-toastr";
import bs from "../../apis/consolidabs";
import dropdown from "../../data/dropdown";

toastr.init();

export default {
  data() {
    return {
      saveEnabled: true,
      showFilter: false,
      showDelConfirm: false,
      horizontal: true,
      layouts:[],
      lkuCoaShow:false,
      lkuCoaCaller:'tblAktiva',
      tahun:2018,
      isLoading:false,
      filter:{newLayout:''},
      contextMenu:[
        {name:'Insert 2 Rows', handler:'insert2Row'},
        {name:'Insert 4 Rows', handler:'insert4Row'},
        {name:'Insert 6 Rows', handler:'insert6Row'}
      ],
      aktiva : {},
      pasiva : {},
      tblAktiva: {
        items: [{nomor:1,kodeacc:''},{nomor:2,kodeacc:''}],
        selected:{},
        obj:{},
        fields: [
          {
            key: "kodeacc",
            label: "Account",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "spasi",
            thStyle: "width:40px",
            label: "Space"
          },
          {
            key: "judul",
            thStyle: "width:40px",
            label: "Bold"
          },
          {
            key: "nm_rumus",
            thStyle: "width:50px",
            label: "Row Name"
          },
          {
            key: "rumus",
            label: "Row Formula",
          },
          {
            key: "garis",
            thStyle: "width:40px",
            label: "Flag Total"
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:100px",
          },
        ],        
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      tblPasiva: {
        items: [{nomor:1,kodeacc:''},{nomor:2,kodeacc:''}],
        selected:{},
        obj:{},
        fields: [
          {
            key: "kodeacc",
            label: "Account",
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "spasi",
            thStyle: "width:40px",
            label: "Space"
          },
          {
            key: "judul",
            thStyle: "width:40px",
            label: "Bold"
          },
          {
            key: "nm_rumus",
            thStyle: "width:50px",
            label: "Row Name"
          },
          {
            key: "rumus",
            label: "Row Formula",
          },
          {
            key: "garis",
            thStyle: "width:40px",
            label: "Flag Total"
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:100px",
          },
        ],        
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      dataList: {
        YesNo: dropdown.YesNo,
        FontBold: dropdown.FontBold,
        FlagTotal: dropdown.FlagTotal
      }      

    };
  },
components: { lkuCoa,Loading,VueSimpleContextMenu },  
computed:{
      layout() {
          return this.filter.layout;
      }
  },
watch:{
      layout: async function(newval) {
          this.filter.newLayout=newval;
          const neracafmt = await bs.layoutSet({layout : newval});
          this.tblAktiva.items = neracafmt[0];
          this.tblPasiva.items = neracafmt[1];
      }
  },  
created: async function (){
     this.layouts = await bs.layout_combo();
     const { user } = this.$store.state;
     this.tahun=moment(user.tglaktifconsol).format('YYYY');
    //  this.filter.layout=this.layouts[0].value;
  },
  methods: {
    data: function(ctx) {
      return this.tblAktiva.items;
    },
    saveLayout: async function(){
      if (this.filter.newLayout){
        // console.log('save');
        try {
          this.isLoading=true;
          const lines = [];
          const pjgPasiva = this.tblPasiva.items.length;
          let line = {};
          let index;
          for (index = 0; index < this.tblAktiva.items.length; index += 1) {
              line = {
                  kodefmt: this.filter.newLayout,
                  idrowunik: this.tblAktiva.items[index].idrowunik,
                  nomor: index,
                  kodeacc: this.tblAktiva.items[index].kodeacc,
                  uraian: this.tblAktiva.items[index].uraian,
                  judul: this.tblAktiva.items[index].judul,
                  spasi: this.tblAktiva.items[index].spasi,
                  nm_rumus: this.tblAktiva.items[index].nm_rumus,
                  rumus: this.tblAktiva.items[index].rumus,
                  garis: this.tblAktiva.items[index].garis,
                  kodeacc2: '',
                  uraian2: '',
                  judul2: '',
                  spasi2: 0,
                  nm_rumus2: '',
                  rumus2: '',
                  garis2: '',
              };
              if (index < pjgPasiva) {
                  line.kodeacc2 = this.tblPasiva.items[index].kodeacc;
                  line.uraian2 = this.tblPasiva.items[index].uraian;
                  line.judul2 = this.tblPasiva.items[index].judul;
                  line.spasi2 = this.tblPasiva.items[index].spasi;
                  line.nm_rumus2 = this.tblPasiva.items[index].nm_rumus;
                  line.rumus2 = this.tblPasiva.items[index].rumus;
                  line.garis2 = this.tblPasiva.items[index].garis;
              };
              if (this.filter.newLayout !== this.filter.layout) {
                  line.idrowunik='';
              }

              lines.push(line);
          };

          while (index < pjgPasiva) {
              line = {
                  kodefmt: this.filter.newLayout,
                  idrowunik: this.tblPasiva.items[index].idrowunik,
                  nomor: index,
                  kodeacc: '',
                  uraian: '',
                  judul: '',
                  spasi: 0,
                  nm_rumus: '',
                  rumus: '',
                  garis: '',
                  kodeacc2: this.tblPasiva.items[index].kodeacc,
                  uraian2: this.tblPasiva.items[index].uraian,
                  judul2: this.tblPasiva.items[index].judul,
                  spasi2: this.tblPasiva.items[index].spasi,
                  nm_rumus2: this.tblPasiva.items[index].nm_rumus,
                  rumus2: this.tblPasiva.items[index].rumus,
                  garis2: this.tblPasiva.items[index].garis,
              };
              if (this.filter.newLayout !== this.filter.layout) {
                  line.idrowunik='';
              }
              lines.push(line);
              index += 1;
          };

          await bs.layoutSave({kodefmt:this.filter.newLayout, lines:lines});
          this.layouts.push({value:this.filter.newLayout, text:this.filter.newLayout});
          this.isLoading=false;
        } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
        }
      } else {
            toastr.error('Please Fill "New Layout Name"');
      }
    },
    delLayout: async function(){
        this.isLoading=true;
        try {
          await bs.layoutDel(this.filter);
          this.layouts = await bs.layout_combo();
          this.isLoading=false;          
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
          
        }

    },
    close(){
      router.push("home");
    },
    closeAktivaLine: function(){
        const opened= this.tblAktiva.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    closePasivaLine: function(){
        const opened= this.tblPasiva.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },

    aktivaClicked(record, index) {
      this.closeAktivaLine();
      if (this.aktiva.index == index) {
        this.editAktiva(this.aktiva);
      } else {
        if ((this.aktiva) && (this.aktiva._rowVariant)) {
            delete this.aktiva._rowVariant;
        }
        this.aktiva = record;
        this.aktiva.index = index;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    pasivaClicked(record, index) {
      this.closePasivaLine();
      if (this.pasiva.index == index) {
        this.editPasiva(this.pasiva);
      } else {
        if ((this.pasiva) && (this.pasiva._rowVariant)) {
            delete this.pasiva._rowVariant;
        }
        this.pasiva = record;
        this.pasiva.index = index;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },

    // addAktiva : function () {
    //     const obj={_showDetails:true};
    //     this.tblAktiva.selected = obj;
    //     for (var key in this.tblAktiva.obj) {
    //         this.tblAktiva.obj[key] = '';
    //     }
    //     this.tblAktiva.items.push(obj);
    //     this.tblAktiva.total=this.tblAktiva.items.length;
    // },
    editAktiva : function (obj,callback) {            
        this.closeAktivaLine();
        this.tblAktiva.selected = obj;
        for (var key in this.tblAktiva.obj) {
            this.tblAktiva.obj[key] = '';
        }
        for (var key in obj) {
            this.tblAktiva.obj[key] = obj[key];
        }
        if (callback) { callback(); 
        } else {
            // this.tblAktiva.selected._showDetails = true;
            this.$set(obj, '_showDetails', true);
        }
    },
    delAktiva: function (index) {
        if (index > -1) {
        this.tblAktiva.items.splice(index, 1);
        }
        this.tblAktiva.total=this.tblAktiva.items.length;
    },
    saveAktiva: function (callback) {
            for (var key in this.tblAktiva.obj) {
                this.tblAktiva.selected[key] = this.tblAktiva.obj[key];
            }
            // this.tblAktiva.selected._showDetails=false;
            if (callback) { callback();
            } else {
             this.$set(this.tblAktiva.selected, '_showDetails', false);
            }
            const sortedLines= this.tblAktiva.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
            this.tblAktiva.items= sortedLines;                
    },
    insertAktiva (event, item, index) {
      // this.contextMenu=[
      //   {name:'Insert 2 Rows', handler:'insert2Row', index:index},
      //   {name:'Insert 4 Rows', handler:'insert4Row', index:index},
      //   {name:'Insert 6 Rows', handler:'insert6Row', index:index},
      // ],
        this.contextMenu.forEach((m,i) => {
            this.contextMenu[i].index=index;
            this.contextMenu[i].callerObj='tblAktiva';
        });
        this.$refs.vueSimpleContextMenu.showMenu(event, item);
    },    
    editPasiva : function (obj,callback) {            
      this.closePasivaLine();
        this.tblPasiva.selected = obj;
        for (var key in this.tblPasiva.obj) {
            this.tblPasiva.obj[key] = '';
        }
        for (var key in obj) {
            this.tblPasiva.obj[key] = obj[key];
        }
        if (callback) { callback(); 
        } else {
            // this.tblPasiva.selected._showDetails = true;
            this.$set(obj, '_showDetails', true);
        }
    },
    delPasiva: function (index) {
        if (index > -1) {
        this.tblPasiva.items.splice(index, 1);
        }
        this.tblPasiva.total=this.tblPasiva.items.length;
    },
    savePasiva: function (callback) {
            for (var key in this.tblPasiva.obj) {
                this.tblPasiva.selected[key] = this.tblPasiva.obj[key];
            }
            // this.tblPasiva.selected._showDetails=false;
            if (callback) { callback();
            } else {
             this.$set(this.tblPasiva.selected, '_showDetails', false);
            }
            const sortedLines= this.tblPasiva.items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
            this.tblPasiva.items= sortedLines;                

    },
    insertPasiva (event, item, index) {
      // this.contextMenu=[
      //   {name:'Insert 2 Rows', handler:'insert2Row', index:index},
      //   {name:'Insert 4 Rows', handler:'insert4Row', index:index},
      //   {name:'Insert 6 Rows', handler:'insert6Row', index:index},
      // ],
        this.contextMenu.forEach((m,i) => {
            this.contextMenu[i].index=index;
            this.contextMenu[i].callerObj='tblPasiva';
        });
        this.$refs.vueSimpleContextMenu.showMenu(event, item);
    },    
    optionClicked (event) {
        this[event.option.handler](event.option.index,event.option.callerObj,event.item);
    },
    insert2Row (index,callerObj,item) {
        let nomor=item.nomor;
        this[callerObj].items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2});  
        for (let idx = this[callerObj].items.length; idx > 0; idx-=1) {
          this[callerObj].items[idx-1].nomor = idx;
        }             
        const sortedLines= this[callerObj].items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this[callerObj].items= sortedLines;                
    },
    insert4Row (index,callerObj,item) {
        let nomor=item.nomor;
        this[callerObj].items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2},{nomor: nomor+3},{nomor: nomor+4});        
        for (let idx = this[callerObj].items.length; idx > 0; idx-=1) {
          this[callerObj].items[idx-1].nomor = idx;
        }             
        const sortedLines= this[callerObj].items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this[callerObj].items= sortedLines;                
    },
    insert6Row (index,callerObj,item) {
        let nomor=item.nomor;
        this[callerObj].items.splice(index, 0, {nomor: nomor+1 },{nomor: nomor+2},{nomor: nomor+3},{nomor: nomor+4},{nomor: nomor+5},{nomor: nomor+6});        
        for (let idx = this[callerObj].items.length; idx > 0; idx-=1) {
          this[callerObj].items[idx-1].nomor = idx;
        }             
        const sortedLines= this[callerObj].items.sort((a, b) => parseInt(a.nomor) - parseInt(b.nomor));   
        this[callerObj].items= sortedLines;                
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this[this.lkuCoaCaller].obj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this[this.lkuCoaCaller].obj.kodeacc = _selected.kodeacc;
        this[this.lkuCoaCaller].obj.namaacc = _selected.namaacc;
        this[this.lkuCoaCaller].obj.uraian = _selected.namaacc;
        this.lkuCoaShow=false;
    },
  }
};
</script>
